import { defaultTo } from "lodash";
import { ILicenseTypeModel, IModel, IPhotoModel, IStateModel, LicenseTypeModel, Model, PhotoModel, StateModel } from ".";

export interface ILicenseModel extends IModel {
    licenseId: number
    number: string
    expirationDate: string
    isReadOnly: boolean
    state: IStateModel
    licenseType: ILicenseTypeModel
    licensePhoto: IPhotoModel | undefined
}

export class LicenseModel extends Model implements ILicenseModel {
    licenseId: number;
    number: string;
    expirationDate: string;
    isReadOnly: boolean;
    state: IStateModel;
    licenseType: ILicenseTypeModel;
    licensePhoto: IPhotoModel | undefined;

    constructor(params: Partial<ILicenseModel>) {
        super(params);
        this.licenseId = defaultTo(params?.licenseId, 0);
        this.number = defaultTo(params?.number, '0');
        this.expirationDate = defaultTo(params?.expirationDate, '');
        this.isReadOnly = defaultTo(params?.isReadOnly, false);
        this.state = new StateModel(params?.state);
        this.licenseType = new LicenseTypeModel(params?.licenseType);
        this.licensePhoto = params?.licensePhoto ? new PhotoModel(params?.licensePhoto) : undefined;
    }
}
